import { useTheme } from '@material-ui/core';
import React from 'react';

import { valueTextStyle } from './styles';

interface OrderLinkProps {
  orderId?: number;
  orderRef?: string | null;
}

export const OrderLink: React.FC<OrderLinkProps> = ({ orderId, orderRef }) => {
  const theme = useTheme();
  const dynamicTextStyle = valueTextStyle(theme);

  if (!orderRef) return null;

  return (
    <a
      href={`#/orders/${orderId}`}
      style={{ ...dynamicTextStyle, color: theme.palette.primary.main, textDecoration: 'underline' }}
      target="_blank"
      rel="noopener noreferrer"
    >
      {orderRef}
    </a>
  );
};
